// extracted by mini-css-extract-plugin
module.exports = {"main":"Breadcrumb_main__27_hN"};